<template>
    <div id="app">
        <Header/>
        <div class="mainbody">
            <router-view/>
        </div>
        <email-verification-modal></email-verification-modal>
        <Footer/>
    </div>
</template>

<script>
import Footer from "./components/Footer.vue";
import Header from "./components/Header"
import EmailVerificationModal from "@/views/EmailVerificationModal.vue";

export default {
    name: "App",
    components: {
        EmailVerificationModal,
        Footer,
        Header,
    },
};
</script>

<style lang="scss">

.mainbody {
  min-height: 505px;
  margin-top: 180px;
  margin-bottom: 10%;
  // margin: 0px;
  // position: relative;
  // min-height: 100%;
  // height: auto;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

html {
  min-height: 100%;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.guest-links .nav-link {
  color: white !important;
}

.sidebar-links .nav-link {
  color: #007bff !important;
}

.navbar-light .guest-links .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: #FF5000 !important;
}

.sidebar-links .nav-link:hover {
  color: #0072C6 !important;
}

.navbar-expand-lg .guest-links .dropdown-menu {
  background: #0072C6 !important;
  color: white;
}

@media (max-width: 991px) {
  .fixed-top > > > .b-sidebar {

    height: calc(100% - 100px);
    overflow: auto;
  }
    .mainbody {
        margin-top: 250px;
    }
}

.fixed-top > > > .b-sidebar {
  margin-top: 104px;
}

</style>
